import React, { Component } from 'react';
import Constants from '../../../definitions/constants';
import JavascriptUtilsTooling from '../../../tooling/javascriptUtilsTooling';
import toastr from 'toastr';
import InterfaceTooling from '../../../tooling/interfaceTooling';

import { intl } from '../../../locales/localesConfig';

import Select from '../common/inputs/select';
import TextBox from '../common/inputs/textBox';

class ExportBiReportsMultiModelSelector extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchText: ""
    };
  }

  render() {
    const {
      className,
      values,
      options,
      onChange,
      labelLocale,
      addSelectLocale,
      searchSelectLocale,
      noMoreOptionsLocale,
      additionalControls,
      hideList,
      disabled,
      connector,
      biTemplatesData,
      handleAddButtonClick,
    } = this.props;

    const dataPath = this.props["data-path"];
    const valueAccesor = "model_id"
    const labelAccesor = "name"
    let valuesMap = {};
    let noOptionsLeft = false;
    if(values && options) {
      for(var i=0; i < values.length; i++) {
        valuesMap[values[i][valueAccesor]] = true;
      }
      noOptionsLeft = !connector ? 
      ((options.length - 1) <= Object.keys(valuesMap).length ? true : false) :
      ((options.length) <= Object.keys(valuesMap).length ? true : false);
    }

    return (
      <div className={"custom-input free-text-list select-list multi-model-select-list" + (className ? " " + className : "")}>
        <div className="free-text-list-label">
          {labelLocale}
          {!disabled && (<i className="fas fa-plus-circle" onClick={this.handleAddButtonClick}/>)}
          {additionalControls}
        </div>
        {!hideList && (
          <div className="free-text-list-list-wrapper">
            {values && values.map((item,i) => {
              return (
                <div key={i} className="free-text-list-list-item row_fields free-text-list-list-item-not-empty">
                  <div className="free-text-list-list-item-inner " title={item[labelAccesor]}>{item[labelAccesor]}</div>
                    <Select 
                      ref={(input) => { this.addItemInput = input; }}
                      className="free-text-list-list-add-template"
                      value={item.template_id}
                      labelLocale={"Plantilla"}
                      options={(!biTemplatesData || !item.model_id) ? [] : 
                        InterfaceTooling.getSelectArrayFromArrayOfObjects(
                          [{"id":"defect", "name": intl.formatMessage({ id: "periodAdmin.exportBiReportsPopup.templateLabelDefect" })}].concat(
                          biTemplatesData.filter(biTemplate => (biTemplate.polynomial_id==item.model_id && !biTemplate.is_outdated))), 
                          "id", "name", false)}   
                      data-selectlist={i}
                      data-path={"template_id"}
                      onChange={onChange}
                    />
                  {!disabled && (
                    <div className="free-text-list-list-item-action-buttons">
                      <i 
                        className="fas delete-action fa-trash"                          
                        data-index={i}
                        data-delete={"true"}
                        data-selectlist={"true"}
                        data-path={dataPath}
                        onClick={onChange}
                      />
                    </div>
                  )}
                </div>
              );           
            })}
            {(!noOptionsLeft) ? (
              <div className="free-text-list-list-item free-text-list-list-item-add">
                <div className="free-text-list-list-item-inner">
                  {!disabled && (
                    <Select 
                      ref={(input) => { this.addItemInput = input; }}
                      className="free-text-list-list-add-item"
                      value={""}
                      labelLocale={addSelectLocale}
                      options={options ? options.filter(option => !(option.value in valuesMap)) : []}                  
                      data-selectlist={"true"}
                      data-path={dataPath}
                      onChange={onChange}
                    />
                  )}
                </div>
              </div>
            ) : (              
              <div className="free-text-list-list-item free-text-list-list-item-add">
                {!disabled && (
                  <div className="free-text-list-list-item-inner message" title={noMoreOptionsLocale}>
                    {noMoreOptionsLocale}
                  </div>
                )}
              </div>
            )}
          </div>
        )}
      </div>
    );
  }
}

export default ExportBiReportsMultiModelSelector;



// WEBPACK FOOTER //
// ./source/client/components/exportConfigurationsAdmin/exportBiReportsMultiModelSelector.jsx